module.exports = __webpack_public_path__ + "images/stickers/taco-cool.64fe3a94c68dbdfcdd99.png";